import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;
const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

export const fetchLoginAudit = async ({ limit = 50, offset = 0, email }, token) => {
  const params = { limit, offset };
  if (email) params.email = email;
  const res = await axios.get(`${API}/admin/audit/logins`, { params, withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const fetchLoginSessions = async ({ limit = 200, email }, token) => {
  const params = { limit };
  if (email) params.email = email;
  const res = await axios.get(`${API}/admin/audit/sessions`, { params, withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const adminTranslate = async ({ texts, target_lang, source_lang }, token) => {
  const res = await axios.post(`${API}/admin/translate`, { texts, target_lang, source_lang }, {
    withCredentials: true,
    headers: authHeaders(token)
  });
  return res.data; // { translated_texts, target_lang }
};